var map = {
	"./etiquete_bio.svg": 51,
	"./etiquete_eco.svg": 52,
	"./etiquete_regen.svg": 53,
	"./etiquete_vegan.svg": 54
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 177;


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images ^\.\/etiquete_.*\.svg$
// module id = 177
// module chunks = 0 1